var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderlineText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_7.Underline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m467.272 440.993h-422.544c-8.976 0-16.252 7.276-16.252 16.252v32.503c0 8.976 7.276 16.252 16.252 16.252h422.544c8.976 0 16.252-7.276 16.252-16.252v-32.503c0-8.976-7.276-16.252-16.252-16.252z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m60.667 71.111h32.555v162.777c0 89.751 73.026 162.777 162.777 162.777s162.777-73.026 162.777-162.777v-162.777h32.555c8.99 0 16.278-7.288 16.278-16.278v-32.555c0-8.99-7.288-16.278-16.278-16.278h-146.5c-8.99 0-16.278 7.288-16.278 16.278v32.555c0 8.99 7.288 16.278 16.278 16.278h32.555v162.777c0 44.95-36.439 81.389-81.389 81.389s-81.389-36.439-81.389-81.389v-162.777h32.555c8.99 0 16.278-7.288 16.278-16.278v-32.555c0-8.99-7.288-16.278-16.278-16.278h-146.5c-8.99 0-16.278 7.288-16.278 16.278v32.555c.004 8.99 7.292 16.278 16.282 16.278z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderlineText);
export default __webpack_public_path__ + "static/media/underline-text.e443c43267c47efbc4d2f186a34692c6.svg";
export { ForwardRef as ReactComponent };